import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { IProduct, IProducts } from '@interfaces/product';

export interface IProductsState extends IProducts {}

export const INITIAL_STATE: IProductsState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
	},
	result: [],
	minimumPrice: 0,
	maximumPrice: 0,
};

@Injectable({
	providedIn: 'root',
})
export class ProductsStore {
	private _productsState = new BehaviorSubject<IProductsState>(INITIAL_STATE);
	readonly productsState$ = this._productsState.asObservable();

	updateProducts(products: IProductsState) {
		const state = this._productsState.value;

		const data = { ...state, ...products };

		this._productsState.next(data);

		return this.productsState$;
	}

	updateProduct(product: IProduct) {
		const state = this._productsState.value;

		const productIndex = state.result.findIndex(({ id }) => id === product.id);

		if (productIndex >= 0) {
			state.result[productIndex] = {
				...state.result[productIndex],
				...product,
			};
		} else {
			state.result.push(product);
		}

		const data = state;

		this._productsState.next(data);

		return this.productsState$;
	}

	deleteProduct(product: IProduct) {
		const state = this._productsState.value;

		const productIndex = state.result.findIndex(({ id }) => id === product.id);

		state.result.splice(productIndex, 1);

		const data = state;

		this._productsState.next(data);

		return this.productsState$;
	}
}
